import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {DashboardComponent} from "./pages/dashboard.component";

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent
  }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class DashboardRoutingModule {
}
